/**
 * NER-4488 fase 2 — Plantillas de grupos de modificadores.
 *
 * Cada plantilla precarga el formulario de "Nuevo grupo" de ModifiersPage:
 * nombre, mínimo/máximo, obligatorio y opciones (todas con precio extra 0, el
 * usuario ajusta). Los textos viven en i18n bajo `modifierTemplates.{id}.*`
 * (`name`, `description`, `options.{key}`).
 *
 * Módulo puro: sin React ni services/api.
 */

/**
 * @typedef {Object} ModifierTemplate
 * @property {string} id
 * @property {string} icon       nombre de icono lucide-react
 * @property {number} minSelect
 * @property {number} maxSelect
 * @property {boolean} required
 * @property {string[]} options  keys i18n de las opciones (`modifierTemplates.{id}.options.{key}`)
 */

/** @type {ModifierTemplate[]} */
export const MODIFIER_TEMPLATES = [
  {
    id: 'size',
    icon: 'Ruler',
    minSelect: 1,
    maxSelect: 1,
    required: true,
    options: ['small', 'medium', 'large'],
  },
  {
    id: 'doneness',
    icon: 'Flame',
    minSelect: 1,
    maxSelect: 1,
    required: true,
    options: ['rare', 'medium', 'wellDone'],
  },
  {
    id: 'extras',
    icon: 'Plus',
    minSelect: 0,
    maxSelect: 5,
    required: false,
    options: ['extraCheese', 'bacon', 'egg', 'avocado', 'caramelizedOnion'],
  },
  {
    id: 'without',
    icon: 'CircleMinus',
    minSelect: 0,
    maxSelect: 5,
    required: false,
    options: ['noOnion', 'noTomato', 'noLettuce', 'noMayo', 'noCheese'],
  },
  {
    id: 'bread',
    icon: 'Wheat',
    minSelect: 1,
    maxSelect: 1,
    required: true,
    options: ['potatoBun', 'brioche', 'wholeWheat', 'glutenFree'],
  },
  {
    id: 'spice',
    icon: 'Thermometer',
    minSelect: 1,
    maxSelect: 1,
    required: true,
    options: ['mild', 'medium', 'hot'],
  },
  {
    id: 'ice',
    icon: 'Snowflake',
    minSelect: 1,
    maxSelect: 1,
    required: true,
    options: ['withIce', 'noIce'],
  },
  {
    id: 'milk',
    icon: 'Milk',
    minSelect: 1,
    maxSelect: 1,
    required: true,
    options: ['whole', 'skim', 'almond', 'oat'],
  },
  {
    id: 'sauce',
    icon: 'Droplets',
    minSelect: 0,
    maxSelect: 2,
    required: false,
    options: ['ketchup', 'mustard', 'mayo', 'bbq', 'chimichurri'],
  },
];

export function getModifierTemplate(templateId) {
  return MODIFIER_TEMPLATES.find((tpl) => tpl.id === templateId);
}
